const initialState = {
  selectedFleet: { id: null, thing_group: null },
  selectedDevice: {},
  fleetDevices: {
    devices: [],
    total: 0,
  },
  queryDevices: {
    devices: [],
    total: 0,
  },
  dialog: {
    open: false,
    data: null,
    type: null,
  },
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_SELECTED_FLEET": {
      state = {
        ...state,
        selectedFleet: action.payload,
      };
      return state;
    }
    case "SET_SELECTED_DEVICE": {
      state = {
        ...state,
        selectedDevice: action.payload,
      };
      return state;
    }
    case "SET_FLEET_DEVICES": {
      state = {
        ...state,
        fleetDevices: action.payload,
      };
      return state;
    }

    case "SET_QUERY_DEVICES": {
      state = {
        ...state,
        queryDevices: action.payload,
      };
      return state;
    }
    case "SHOW_DIALOG": {
      const { data, type } = action.payload;
      state = {
        ...state,
        dialog: {
          open: true,
          data,
          type,
        },
      };
      return state;
    }
    case "HIDE_DIALOG": {
      state = {
        ...state,
        dialog: {
          open: false,
          data: null,
          type: null,
        },
      };
      return state;
    }
    default:
      return state;
  }
}
